import React, { Component } from 'react';
import { connect } from 'react-redux';

import Handlers from 'reports/containers/EmployeesAssetsReportHandlers';
import EmployeesAssetsReportRow from 'reports/containers/EmployeesAssetsReportRowContainer';
import * as Reports from 'reports/components';

import { getCompany, getSubcompany, getPermissions } from 'auth/selectors';
import {
  getEmployeesAssetsReportPagination,
  getEmployeesAssetsReportFilters,
  getEmployeesAssetsReportIsLoading,
  getEmployeesAssetsReportVisibleRecords,
} from 'reports/selectors';

class EmployeesAssetsReportContainer extends Component {
  renderRows = () =>
    this.props.records.map((record) => (
      <EmployeesAssetsReportRow key={record.id} record={record} />
    ));

  render = () => (
    <Handlers
      render={({
        handleFiltersChange,
        handleFiltersSubmit,
        handleLimitChange,
        handleOrderChange,
        handlePageChange,
      }) => (
        <Reports.EmployeesAssetsReportView
          company={this.props.company}
          count={this.props.records.length}
          pagination={this.props.pagination}
          filters={this.props.filters}
          permissions={this.props.permissions}
          isLoading={this.props.isLoading}
          records={this.props.records}
          subcompany={this.props.subcompany}
          handleFiltersChange={handleFiltersChange}
          handleFiltersSubmit={handleFiltersSubmit}
          handleLimitChange={handleLimitChange}
          handleOrderChange={handleOrderChange}
          handlePageChange={handlePageChange}
        >
          {this.renderRows()}
        </Reports.EmployeesAssetsReportView>
      )}
    />
  );
}

const mapStateToProps = (state) => ({
  company: getCompany(state),
  subcompany: getSubcompany(state),
  pagination: getEmployeesAssetsReportPagination(state),
  permissions: getPermissions(state),
  filters: getEmployeesAssetsReportFilters(state),
  isLoading: getEmployeesAssetsReportIsLoading(state),
  records: getEmployeesAssetsReportVisibleRecords(state),
});

export default connect(mapStateToProps, null)(EmployeesAssetsReportContainer);



// WEBPACK FOOTER //
// src/modules/secured/modules/reports/containers/EmployeesAssetsReportContainer.js